import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

const controlStyles = {
    borderRadius: '1px solid black',
    color: 'white',
};

const ControlComponent = (props) => (
    <div style={controlStyles}>
        <components.Control {...props} />
    </div>
);

const FactoryDropdownMultiple = ({ getFactory, modalInfo }) => {
    const [factorySelect, setFactorySelect] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        const getFactories = async () => {
            const factoryFromServer = await fetchFactory();
            setFactorySelect(factoryFromServer);
        };

        if (modalInfo) {
            const [factoryList] = 
                [modalInfo.factory];
            if(factoryList[0] != 0){
                const [factoryList] = 
                [modalInfo.factory.split(',')];
                const factory = factoryList.map((node, index) => ({
                    value: node,
                    label: factoryList[index]
                }));
                setSelectedOption(factory)
            }
        }

        getFactories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalInfo]);

    // Fetch Categories
    const fetchFactory = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/grievance/getfactoryAndCategorylist'
        );
        const data = await res.json();

        return data.grievanceFactoryList;
    };

    const options = factorySelect.map((factory, index) => {
        return {
            value: factory.id,
            label: factory.factory
        }
    })

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);


        if (selectedOption) {
            getFactory(
                Array.isArray(selectedOption)
                ? selectedOption.map((item) => item.label)
                : null
            )
        }

    };

    return (
        <Select
            placeholder={'Select a factory...'}
            components={{ Control: ControlComponent }}
            value={selectedOption}
            onChange={handleChange}
            options={options}
            isMulti
            isClearable
        />
    );
};

export default FactoryDropdownMultiple;
